import gql from 'graphql-tag'

export default gql`mutation authenticateForgotPassword($email: String!) {
	authenticateForgotPassword(email: $email, client: "admin_portal") {
		deliveryMedium
		destination
  }
}`
